<template>
  <div ref="wrapperRef" :class="brandClasses.wrapper">
    <cms-mega-menu-visual-selector
      v-for="{ component, isWide } in slicedItems"
      :key="component.id"
      class="flex-1"
      :class="[
        !$feature.tempMegaMenuDesktopRedesign && dynamicPosition
          && (slicedItems.length === 1 ? 'lg:w-full' : 'lg:w-1/4'),
        { [brandClasses.card]: Object.values(isWide).some(Boolean) },
      ]"
      :content="component"
      :is-wide
    />
  </div>
</template>

<script setup lang="ts">
import type { Responsive } from '#types/common'
import type { VisualSelectorComponent } from '#types/components/cms/mega-menu'
import { MegaMenuVisualSelectorContextKey } from '#content/contexts/megamenu'

const { content } = defineProps<{
  content: VisualSelectorComponent
}>()

const { oddImageSize, items } = content

const appConfig = useAppConfig()
const { breakpoints } = appConfig.ds
const { brandClasses, dynamicPosition, resizeEnabled } = appConfig.components.cms.megaMenuVisualSelectorCollection
const { $feature } = useNuxtApp()

const resolveIsWide = (isWide: boolean): Responsive<boolean> => {
  if (typeof resizeEnabled === 'boolean') {
    const value = isWide && resizeEnabled
    return { sm: value, md: value, lg: value }
  }

  return Object.fromEntries(
    Object.entries(breakpoints).map(([k]) => [k, isWide && resizeEnabled[k]]),
  ) as Responsive<boolean>
}

const slicedItems = items?.slice(0, $feature.tempMegaMenuDesktopRedesign ? 6 : 4).map((component, index, array) => ({
  component,
  isWide: resolveIsWide(index === 0 && !!oddImageSize && array.length % 2 !== 0),
})) || []

const wrapperRef = useTemplateRef('wrapperRef')

const visualSelectorCount = inject(MegaMenuVisualSelectorContextKey, undefined)
if (visualSelectorCount) {
  whenever(useElementVisibility(wrapperRef), () => {
    visualSelectorCount.value = slicedItems.length
  }, { immediate: true })
}
</script>
